export const constant = {
    SAVE_TEACHER_IN_PROGRESS: "SAVE_TEACHER_IN_PROGRESS",
    SAVE_TEACHER_COMPLETE: "SAVE_TEACHER_COMPLETE"
  };
  